import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import useTheme from "@material-ui/core/styles/useTheme";
import * as PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import LoginForm from "../../components/Auth/LoginForm";
import RegisterForm from "../../components/Auth/RegisterForm";
import {Grid} from "@material-ui/core";
import {login, register} from "../../services/authService";
import {connect} from "react-redux";
import ResetForm from "../../components/Auth/ResetForm";
import {hideAlert, hideSuccessAlert} from "../../store/actions/common";
import {showFAlert, showSAlert} from "../../utils/functions";
import {validateRegistration} from "../../utils/validators";
const urlParams = new URLSearchParams(window.location.search);
function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
let theme = createMuiTheme();

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '50px',
    },
    form: {
        justifyContent: 'center',
        width: '60%'
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }
});

class LoginRegister extends React.Component {
    constructor() {
        super();
        this.state = {
            currentTab: 'login',
            val: 0
        }
    }

    handleChange = (event, newValue) => {
        this.setState({val: newValue});
    };
    componentDidMount() {
        if (urlParams.get('type')) {
            showSAlert('Успех', urlParams.get('message'), this.props.dispatch);
        }
    }

    componentWillUnmount() {
        this.props.dispatch(hideSuccessAlert());
        this.props.dispatch(hideAlert());
    }

    render() {
        const {classes, dispatch} = this.props;
        const isResetPassword = urlParams.get('type') === 'reset';
        return (
            <div className={classes.wrapper}>
                <div>
                    <Typography variant={'h3'} component={'div'} className={classes.top}>
                        <a target={'_blank'} href={'https://help-chat.com.ua'} style={{display: 'contents'}}><img src={'/space/icon-256.png'} style={{width: '100px', marginRight: '20px'}}/></a>Help-Chat
                    </Typography>
                </div>
                <div className={classes.root}>

                    <AppBar className={classes.form} position="static" color="default">
                        <Tabs
                            value={this.state.val}
                            onChange={this.handleChange}
                            indicatorColor="secondary"
                            textColor="secondary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                        >
                            {!isResetPassword && <Tab label="Вход" {...a11yProps(0)} />}
                            {!isResetPassword && <Tab label="Регистрация" {...a11yProps(1)} />}
                            {isResetPassword && <Tab label="Сброс" {...a11yProps(0)} />}
                        </Tabs>
                        {!isResetPassword && <TabPanel value={this.state.val} index={0} dir={theme.direction}>
                            <LoginForm
                                onSubmit = {(credentials) => dispatch(login(credentials))}
                                dispatch = {dispatch}
                            />
                        </TabPanel>}
                        {!isResetPassword && <TabPanel value={this.state.val} index={1} dir={theme.direction}>
                            <RegisterForm
                                onSubmit={(credentials) => {
                                    let error = validateRegistration(credentials);
                                    if (error) {
                                        showFAlert('Ошибка', error, dispatch);
                                    } else {
                                        dispatch(register(credentials))
                                    }
                                }}
                            />
                        </TabPanel>}
                        {isResetPassword && <TabPanel index={this.state.val} value={0} dir={theme.direction}>
                            <ResetForm
                                token={urlParams.get('token')}
                                email={urlParams.get('email')}
                            />
                        </TabPanel>}
                        </AppBar>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.Auth.isAuthenticated,
    }
}

export default connect(mapStateToProps)(withStyles(styles)(LoginRegister))

